import { computed } from "vue";
import {} from "@/components/ObjectStore/Templates/types";
import { useObjectStoreInstancesStore } from "@/stores/objectStoreInstancesStore";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import {} from "./types";
export function useInstanceAndTemplate(instanceIdRef) {
    const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
    const objectStoreInstancesStore = useObjectStoreInstancesStore();
    objectStoreInstancesStore.fetchInstances();
    objectStoreTemplatesStore.fetchTemplates();
    const instance = computed(() => objectStoreInstancesStore.getInstance(instanceIdRef.value) || null);
    const template = computed(() => instance.value
        ? objectStoreTemplatesStore.getTemplate(instance.value?.template_id, instance.value?.template_version)
        : null);
    return { instance, template };
}
